import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { patientAction } from '../../actions/constant';
import patientService from 'src/services/apiServices/patientServices';

const { GET_ALL_PATIENT_FAILURE, GET_ALL_PATIENT_REQUEST, GET_ALL_PATIENT_SUCCESS } = patientAction;

function* getAllPatient(): SagaReturnType<any> {
  try {
    // THIN-8229: the NPC patient picker (the only consumer of this saga) must include inactive
    // patients, so fetch from the dedicated all-non-archived endpoint rather than /active/true.
    const response = yield call(patientService.getAllUnarchivedPatients);
    if (response?.status === 200) {
      yield put({ type: GET_ALL_PATIENT_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_ALL_PATIENT_FAILURE, payload: error });
  }
}

function* getAllPatientSaga() {
  yield takeEvery(GET_ALL_PATIENT_REQUEST, getAllPatient);
}

export default getAllPatientSaga;
